export default __webpack_public_path__ + "media/images/casatb/tenant/diamond-one-0872d34b4ea820f69ea37ce4756b3806.png";